import { SaveButton } from '@lib/core/src';
import palette from '@lib/core/src/theme/palette';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { Stack, Typography } from '@mui/material';

export const EmptyTasks: React.FC<{
  openTaskModal?: () => void;
  hideButton?: boolean;
  containerStyling?: React.CSSProperties;
}> = ({ openTaskModal, hideButton = false, containerStyling = {} }) => (
  <Stack
    sx={{
      backgroundColor: palette.grey[800],
      borderRadius: '8px',
      flex: 1,
      alignItems: 'center',
      height: '100%',
      justifyContent: 'center',
      ...containerStyling
    }}
  >
    <CheckCircleOutlineIcon sx={{ fontSize: '33px', color: palette.grey[500] }} />
    <Typography sx={{ fontSize: '16px', fontWeight: 500, color: palette.black, marginTop: '20px' }}>
      No Open Tasks
    </Typography>
    <Typography
      sx={{
        fontSize: '13px',
        fontWeight: 500,
        color: palette.grey[400],
        maxWidth: '360px',
        textAlign: 'center',
        marginTop: '8px'
      }}
    >
      You have no open tasks on your table now. Feel free to create some, or just wait until we will
      generate it for you.
    </Typography>
    {!hideButton && (
      <SaveButton
        sx={{
          fontSize: '13px',
          color: palette.white,
          marginTop: '24px',
          height: '32px',
          width: '118px',
          padding: '8px 0px'
        }}
        onClick={openTaskModal}
      >
        Create New Task
      </SaveButton>
    )}
  </Stack>
);
